import React, { Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import GoogleMapReact from 'google-map-react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SearchIcon from '@mui/icons-material/Search';

const shopList = [
  { id: 'Loughton', fullName: 'Phoneclinic Loughton', shopAddress: '224 High Road, Loughton IG10 1ET', gLocation: 'https://maps.app.goo.gl/x6wtzXHMvDSvsduF8', emailAdd: 'phoneclinicloughton224@gmail.com', lat: '51.6433', lng: '0.0756' },
  { id: 'Thames', fullName: 'Phoneclinic Thames', shopAddress: '3 Bell Street, Henley-on-Thames, Oxfordshire RG9 2BA', gLocation: 'https://maps.app.goo.gl/dTMcmEX83oDEpUdZ9', emailAdd: 'phoneclinicthames321@gmail.com', lat: '51.5354', lng: '-0.9003' },
  { id: 'Bitterne', fullName: 'Phoneclinic Bitterne', shopAddress: '414 Bitterne Road, Southampton SO18 1DT', gLocation: 'https://maps.app.goo.gl/sZku3KuBfroQ4FwWA', emailAdd: 'phoneclinicbittern@gmail.com', lat: '50.9230', lng: '-1.3666' },
  { id: 'Birkenhead', fullName: 'Phoneclinic Birkenhead', shopAddress: '178 Grange Road, Birkenhead, Merseyside CH41 6EA', gLocation: 'https://maps.app.goo.gl/A8SGisWmCsswNxtd8', emailAdd: 'Phoneclinicbirkenhead@gmail.com', lat: '53.3911', lng: '-3.0168' },
  { id: 'Shrewsbury', fullName: 'Phoneclinic Shrewsbury', shopAddress: '38 Pride Hill, Shrewsbury SY1 1DN', gLocation: 'https://maps.app.goo.gl/fQ5zUL2Jdkc4MH3F6', emailAdd: 'phoneclinicshrewsbury38@gmail.com', lat: '52.7086', lng: '-2.7521' },
  { id: 'FortWilliam', fullName: 'Phoneclinic Fort William', shopAddress: '63 High Street, Fort William PH33 6DH', gLocation: 'https://maps.app.goo.gl/ndB5s6KBmHHRjeFJ9', emailAdd: 'phoneclinicfortwilliam03@gmail.com', lat: '56.8198', lng: '-5.1052' },
  { id: 'EastGate', fullName: 'Phoneclinic EastGate', shopAddress: 'Unit 40, Eastgate, Inverness IV2 3PP', gLocation: 'https://maps.app.goo.gl/mqJ9uob1uyRACtj39', emailAdd: 'phonecliniceastgate417@gmail.com', lat: '57.4778', lng: '-4.2247' },
  { id: 'Inverness', fullName: 'Phoneclinic Inverness', shopAddress: '32 High St, Inverness IV1 1JQ', gLocation: 'https://maps.app.goo.gl/oxCGGkpf82GZscBd9', emailAdd: 'pcinverness1@gmail.com', lat: '57.4778', lng: '-4.2247' },
  { id: 'Hanley', fullName: 'Phoneclinic — Phone Village', shopAddress: '6 Upper Market Square, Hanley, Stoke on Trent ST1 1NS', gLocation: 'https://maps.app.goo.gl/LhouTvAmfRPtTSde9', emailAdd: 'hanleyphonevillage@gmail.com', lat: '53.0265', lng: '-2.1744' },
  { id: 'Scunthrope', fullName: 'Phoneclinic — Phone Village', shopAddress: '70 High Street, Scunthorpe DN15 6SD', gLocation: 'https://maps.app.goo.gl/t6ZX7NbRLyWBFKot6', emailAdd: 'phonevillage402@gmail.com', lat: '53.5889', lng: '-0.6546' },
  { id: 'Goole', fullName: 'Phoneclinic — Goole Mobile Shop', shopAddress: 'Unit 06, Wesley Square, Goole DN14 5EZ', gLocation: 'https://maps.app.goo.gl/9wQ35PXfsZcam3um7', emailAdd: 'Goolemobileshop06@gmail.com', lat: '53.7028', lng: '-0.8734' },
  { id: 'Liverpool', fullName: 'Phoneclinic — Mobile Hub', shopAddress: '26 Whitechapel Rd, City Centre, Liverpool L1 6DZ', gLocation: 'https://maps.app.goo.gl/xJT7mhMPVRNfZNna7', emailAdd: 'mobilehubliverpool2426@gmail.com', lat: '53.4084', lng: '-2.9916' },
  { id: 'Oban', fullName: 'Phoneclinic — Oban Mobile Shop', shopAddress: '125 George Street, Oban PA34 5NT', gLocation: 'https://maps.app.goo.gl/t8oScSNz6fvAhEQn8', emailAdd: 'Obanphoneshop@gmail.com', lat: '56.4150', lng: '-5.4720' },
  { id: 'Leeds', fullName: 'Phoneclinic — i Repair', shopAddress: '3 Commercial Street, Leeds LS1 6AL', gLocation: 'https://maps.app.goo.gl/ERaXPcKLH5zhSpKJ7', emailAdd: 'irepairleeds43@gmail.com', lat: '53.7975', lng: '-1.5438' },
  { id: 'Worcester', fullName: 'Phoneclinic — American Candy Shop', shopAddress: '26 High Street, Worcester WR1 2QL', gLocation: 'https://maps.app.goo.gl/xvzv2AbNogxytaY17', emailAdd: 'americancandyworcester26@gmail.com', lat: '52.1936', lng: '-2.2208' },
];

const MapMarker = ({ isActive }) => (
  <div style={{
    width: isActive ? '40px' : '30px',
    height: isActive ? '40px' : '30px',
    background: isActive ? 'linear-gradient(135deg, #c61515, #780e0f)' : 'rgba(198,21,21,0.75)',
    borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    border: `${isActive ? '3px' : '2px'} solid white`,
    boxShadow: isActive ? '0 4px 22px rgba(198,21,21,0.75)' : '0 2px 8px rgba(198,21,21,0.35)',
    transform: 'translate(-50%, -50%)',
    transition: 'all 0.3s',
  }}>
    <LocationOnIcon style={{ color: 'white', fontSize: isActive ? '18px' : '14px' }} />
  </div>
);

class Stores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shop: shopList[0],
      search: '',
    };
  }

  componentDidMount() {
    this.handleUpdateShop(this.props.params.id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.params.id !== prevProps.params.id) {
      this.handleUpdateShop(this.props.params.id);
    }
  }

  handleUpdateShop(id) {
    const found = shopList.find(s => s.id === id);
    if (found) this.setState({ shop: found });
    else window.location.assign('/');
  }

  handleSelectShop(obj) {
    window.history.pushState({}, null, '/stores/' + obj.id);
    this.setState({ shop: obj });
  }

  render() {
    const { shop, search } = this.state;
    const filtered = search
      ? shopList.filter(s =>
          s.fullName.toLowerCase().includes(search.toLowerCase()) ||
          s.shopAddress.toLowerCase().includes(search.toLowerCase())
        )
      : shopList;

    const mapCenter = shop.lat && shop.lng
      ? { lat: parseFloat(shop.lat), lng: parseFloat(shop.lng) }
      : { lat: 53.0, lng: -2.17 };

    return (
      <div style={{ background: '#080808', paddingTop: '78px' }}>

        {/* ── Hero ── */}
        <section style={{
          minHeight: '42vh',
          background: 'linear-gradient(135deg, #0d0d0d 0%, #110404 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          position: 'relative', overflow: 'hidden', padding: '70px 5%',
        }}>
          <div style={{
            position: 'absolute', top: '-15%', right: '-6%', width: '420px', height: '420px',
            borderRadius: '50%', pointerEvents: 'none',
            background: 'radial-gradient(circle, rgba(198,21,21,0.1) 0%, transparent 70%)',
          }} />
          <div style={{
            position: 'absolute', inset: 0, pointerEvents: 'none',
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.012) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.012) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }} />
          <motion.div
            initial={{ opacity: 0, y: 34 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
            style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}
          >
            <div style={{ fontSize: '11px', letterSpacing: '4px', color: '#c61515', fontWeight: '800', marginBottom: '18px' }}>
              FIND US NEAR YOU
            </div>
            <h1 style={{ color: 'white', fontSize: 'clamp(32px, 5.5vw, 58px)', fontWeight: '900', margin: '0 0 20px', lineHeight: '1.1' }}>
              Our{' '}
              <span style={{
                background: 'linear-gradient(135deg, #dd4d4e, #780e0f)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
              }}>
                Locations
              </span>
            </h1>
            <p style={{ color: '#777', fontSize: '15px', maxWidth: '460px', margin: '0 auto', lineHeight: '1.8' }}>
              {shopList.length} stores across the UK — find the one nearest to you.
            </p>
          </motion.div>
        </section>

        {/* ── Locator ── */}
        <section style={{ padding: '60px 5% 80px', background: '#080808' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>

            {/* Search */}
            <motion.div
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}
              style={{
                display: 'flex', alignItems: 'center', gap: '10px',
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '10px', padding: '6px 16px',
                maxWidth: '380px', marginBottom: '22px',
              }}
            >
              <SearchIcon style={{ color: '#555', fontSize: '20px' }} />
              <input
                value={search}
                onChange={e => this.setState({ search: e.target.value })}
                placeholder="Search stores by name or address…"
                style={{
                  background: 'transparent', border: 'none', outline: 'none',
                  color: 'white', fontSize: '13px', flex: 1, padding: '9px 0',
                  fontFamily: 'Catamaran, sans-serif',
                }}
              />
              {search && (
                <span
                  onClick={() => this.setState({ search: '' })}
                  style={{ color: '#555', cursor: 'pointer', fontSize: '18px', lineHeight: 1 }}
                >
                  ×
                </span>
              )}
            </motion.div>

            {/* Grid — Map + List */}
            <div className="stores-grid">
              {/* Map */}
              <motion.div
                initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }}
                className="stores-map"
                style={{
                  borderRadius: '18px', overflow: 'hidden',
                  border: '1px solid rgba(198,21,21,0.2)',
                }}
              >
                <GoogleMapReact
                  bootstrapURLKeys={{ key: '' }}
                  center={mapCenter}
                  defaultZoom={12}
                  key={shop.id}
                >
                  {shop.lat && shop.lng && (
                    <MapMarker
                      lat={parseFloat(shop.lat)}
                      lng={parseFloat(shop.lng)}
                      isActive
                    />
                  )}
                </GoogleMapReact>
              </motion.div>

              {/* Store list */}
              <div className="stores-list" style={{ overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px', paddingRight: '4px' }}>
                <AnimatePresence>
                  {filtered.map((s, i) => {
                    const isActive = s.id === shop.id;
                    return (
                      <motion.div
                        key={s.id}
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 20 }}
                        transition={{ delay: i * 0.03 }}
                        onClick={() => this.handleSelectShop(s)}
                        whileHover={{ x: 4 }}
                        style={{
                          background: isActive ? 'rgba(198,21,21,0.1)' : 'rgba(255,255,255,0.025)',
                          border: `1px solid ${isActive ? 'rgba(198,21,21,0.45)' : 'rgba(255,255,255,0.07)'}`,
                          borderRadius: '12px', padding: '16px',
                          cursor: 'pointer', flexShrink: 0,
                          transition: 'background 0.2s, border-color 0.2s',
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <h6 style={{
                              color: isActive ? '#c61515' : 'white',
                              fontSize: '13px', fontWeight: '800',
                              margin: '0 0 5px', lineHeight: '1.3',
                            }}>
                              {s.fullName}
                            </h6>
                            <div style={{ display: 'flex', gap: '5px', alignItems: 'flex-start' }}>
                              <LocationOnIcon style={{ color: '#c61515', fontSize: '13px', marginTop: '2px', flexShrink: 0 }} />
                              <p style={{
                                color: '#666', fontSize: '12px', margin: 0, lineHeight: '1.5',
                                overflow: 'hidden', display: '-webkit-box',
                                WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                              }}>
                                {s.shopAddress}
                              </p>
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '5px', flexShrink: 0 }}>
                            <a href={s.gLocation} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>
                              <motion.div
                                whileHover={{ background: 'rgba(198,21,21,0.25)' }}
                                style={{
                                  width: '28px', height: '28px',
                                  background: 'rgba(255,255,255,0.06)', borderRadius: '7px',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                                }}
                              >
                                <OpenInNewIcon style={{ color: '#777', fontSize: '13px' }} />
                              </motion.div>
                            </a>
                            <a href={`mailto:${s.emailAdd}`} onClick={e => e.stopPropagation()}>
                              <motion.div
                                whileHover={{ background: 'rgba(198,21,21,0.25)' }}
                                style={{
                                  width: '28px', height: '28px',
                                  background: 'rgba(255,255,255,0.06)', borderRadius: '7px',
                                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                                }}
                              >
                                <MailOutlineIcon style={{ color: '#777', fontSize: '13px' }} />
                              </motion.div>
                            </a>
                          </div>
                        </div>
                      </motion.div>
                    );
                  })}
                </AnimatePresence>
                {filtered.length === 0 && (
                  <div style={{ color: '#555', textAlign: 'center', padding: '40px 20px', fontSize: '14px' }}>
                    No stores match your search.
                  </div>
                )}
              </div>
            </div>

            {/* Selected store detail strip */}
            {shop.fullName && (
              <motion.div
                initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
                key={shop.id}
                style={{
                  marginTop: '16px',
                  background: 'rgba(255,255,255,0.025)',
                  border: '1px solid rgba(198,21,21,0.2)',
                  borderRadius: '12px', padding: '18px 22px',
                  display: 'flex', justifyContent: 'space-between',
                  flexWrap: 'wrap', gap: '14px', alignItems: 'center',
                }}
              >
                <div>
                  <h5 style={{ color: 'white', fontWeight: '800', margin: '0 0 4px', fontSize: '14px' }}>{shop.fullName}</h5>
                  <p style={{ color: '#555', margin: 0, fontSize: '12px' }}>{shop.shopAddress}</p>
                </div>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <a href={`mailto:${shop.emailAdd}`} style={{ textDecoration: 'none' }}>
                    <motion.button
                      whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.96 }}
                      style={{
                        background: 'rgba(198,21,21,0.15)', color: '#c61515',
                        border: '1px solid rgba(198,21,21,0.3)', padding: '8px 18px',
                        borderRadius: '7px', fontSize: '11px', letterSpacing: '1.2px',
                        fontWeight: '800', cursor: 'pointer', fontFamily: 'Catamaran, sans-serif',
                      }}
                    >
                      EMAIL STORE
                    </motion.button>
                  </a>
                  <a href={shop.gLocation} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                    <motion.button
                      whileHover={{ scale: 1.04, boxShadow: '0 0 18px rgba(198,21,21,0.4)' }} whileTap={{ scale: 0.96 }}
                      style={{
                        background: 'linear-gradient(135deg, #c61515, #780e0f)',
                        color: 'white', border: 'none', padding: '8px 18px',
                        borderRadius: '7px', fontSize: '11px', letterSpacing: '1.2px',
                        fontWeight: '800', cursor: 'pointer', fontFamily: 'Catamaran, sans-serif',
                      }}
                    >
                      GET DIRECTIONS
                    </motion.button>
                  </a>
                </div>
              </motion.div>
            )}
          </div>
        </section>
      </div>
    );
  }
}

export default Stores;
